<mat-form-field appearance="outline" class="cntry-cmbo-form-field">
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="countrySelector" (selectionChange)="selectionChanged()" [placeholder]="label">
    <mat-option>None</mat-option>
    <ng-container *ngFor="let location of countries">
      <mat-option [value]="location.id">{{location.value}}</mat-option>
    </ng-container>
  </mat-select>
</mat-form-field>
